export default __webpack_public_path__ + "static/media/wax-logo-white.4ee10a2d.png";